import React from 'react';
import styles from './GameActions.module.css';

const GameActions = ({
  onReveal,
  onRevealYear,
  onNewGame,
  onNextSong,
  gameState,
  currentSong,
  songRevealed,
  yearRevealed,
}) => {
  return (
    <div className={styles.game_actions}>
      {currentSong && !songRevealed && (
        <button onClick={onReveal} className="btn btn-secondary">
          🔍 Reveal Song Info
        </button>
      )}

      {currentSong && songRevealed && !yearRevealed && (
        <button onClick={onRevealYear} className="btn btn-primary">
          🗓️ Reveal Year
        </button>
      )}

      {gameState === 'finished' && (
        <button onClick={onNextSong} className="btn btn-primary">
          ➡️ Next Song
        </button>
      )}

      <button onClick={onNewGame} className="btn btn-outline">
        🔄 New Game
      </button>
    </div>
  );
};

export default GameActions;